<template>
  <div>
    <div class="modal fade" id="modal-feedback-cancel-action">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="onCloseModal()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t(updateFeedbackModalData.title) }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div
                class="col-md-12"
                v-if="
                  statusValue !== feedbackStatusEnum.CANCELED ||
                    statusValue !== feedbackStatusEnum.IN_PROGRESS_CANCEL
                "
              >
                <div class="form-group">
                  {{ $t(updateFeedbackModalData.content) }}
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("feedback.content") }}</label>
                  <textarea
                    class="form-control"
                    name=""
                    id=""
                    cols="30"
                    rows="6"
                    v-model="feedbackComment"
                  ></textarea>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div
                      class="class-border"
                      style="display: flex; justify-content: space-between; padding: 5px 10px;"
                    >
                      <span style="align-self: center;">{{
                        $t("userExtraInfo.attachFileList")
                      }}</span>
                      <div style="width: fit-content;">
                        <span
                          class="btn btn-primary"
                          style="padding: 2px 5px;"
                          @click="onClickAttachFile"
                          ><i class="fa fa-paperclip " aria-hidden="true"></i
                        ></span>
                        <span
                          class="btn btn-danger"
                          style="padding: 2px 5px;"
                          @click="onClickDeleteAttachFile"
                          ><i class="glyphicon glyphicon-trash"></i
                        ></span>
                      </div>
                    </div>
                    <div class="content-border-class attach-file-class">
                      <div
                        v-for="(attachFileItem, index) in attachFileList"
                        :key="attachFileItem + index"
                        style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: flex"
                      >
                        <input
                          type="checkbox"
                          class="form-check-input"
                          :id="index"
                          v-model="attachFileItem.enable"
                        />
                        <label
                          :title="attachFileItem.fileName"
                          class="form-check-label attach-file-name"
                          style="padding-left: 5px;"
                          @click="onClickOpenAttachFile(attachFileItem.pdfUrl)"
                        >
                          {{ attachFileItem.fileName }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div
                      class="class-border"
                      style="display: flex; justify-content: space-between; padding: 5px 10px;"
                    >
                      <span style="align-self: center;">{{
                        $t("banner.image")
                      }}</span>
                      <div style="width: fit-content;">
                        <span
                          class="btn btn-primary"
                          style="padding: 2px 5px;"
                          @click="onOpenInputSelectFile(imgList.length + 1)"
                          ><i class="fa fa-paperclip " aria-hidden="true"></i
                        ></span>
                      </div>
                    </div>
                    <div
                      class="content-border-class attach-file-class"
                    >
                      <div
                        class="apartment-img-block"
                        v-for="(item, index) in imgList"
                        :key="item + index"
                      >
                        <img
                          id="apartment-img-id"
                          class="apartment-type-class img-responsive"
                          :src="item.url"
                          alt="apartment-img"
                        />
                        <div class="img-action">
                          <span
                            style="color: #006ad4"
                            class="action-button"
                            @click="onOpenInputSelectFile(index)"
                            ><small>{{ $t("common.update") }}</small></span
                          >
                          <span
                            style="color: #f2404d"
                            class="action-button"
                            @click="onclickRemoveImg(index)"
                            ><small>{{ $t("common.delete") }}</small></span
                          >
                        </div>
                      </div>
                    </div>
                    <div style="padding-top: 6px; text-align: center">
                      <input
                        class="img-upload-input"
                        :id="`upload-img-input`"
                        type="file"
                        accept="image/*"
                        @change="handleClick"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right"
              @click="onPostCancelFeedback()"
            >
              {{ $t("common.confirm") }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="onCloseModal()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!--  -->
    <component-file-pdf-with-file-name
      ref="componentFilePdfWithFileName"
      :titleModal="uploadPdfFileTitle"
      @uploadPdfFileEmit="handleUpdateAttachFileList"
    />
    <!--  -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils, { uploadFileToMediaAgent } from '@/lib/utils';
import feedbackStatusEnum from "@/enum/feedbackStatusEnum";
import Loading from "vue-loading-overlay";
import ComponentFilePdfWithFileName from "@/components/ComponentFilePdfWithFileName.vue";
export default {
  components: {
    loading: Loading,
    ComponentFilePdfWithFileName
  },
  data: () => ({
    isLoading: false,
    feedbackComment: null,
    feedbackId: null,
    statusValue: null,
    //
    uploadPdfFileTitle: "",
    attachFileList: [],
    imgUploadIndex: 0,
    //
    imgList: [],
    imgUploadData: {
      url: null,
      size: null,
      file: null
    },
    //
    updateFeedbackModalData: {
      title: "",
      content: "",
      status: null
    },
    feedbackStatusEnum: feedbackStatusEnum
  }),
  watch: {},
  computed: {
    ...mapGetters([])
  },
  methods: {
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    onShowModal: function() {
      $("#modal-feedback-cancel-action").modal("show");
    },
    onCloseModal: function() {
      $("#modal-feedback-cancel-action").modal("hide");
    },
    clickCancelFeedback: function(feedbackId, statusValue, ) {
      this.feedbackComment = null;
      this.feedbackId = feedbackId;
      this.statusValue = statusValue;
      this.getTitleModal(statusValue);
      this.attachFileList = []
      this.imgList = []
      this.onShowModal();
    },
    getTitleModal: function(statusValue) {
      if (
        statusValue === feedbackStatusEnum.RECEIVED ||
        statusValue === feedbackStatusEnum.IN_PROGRESS_DOING
      ) {
        this.updateFeedbackModalData.title =
          "feedback.handlingFeedback.confirmFeedbackModal.title";
        this.updateFeedbackModalData.content =
          "feedback.handlingFeedback.confirmFeedbackModal.content";
      } else if (
        statusValue === feedbackStatusEnum.DONE ||
        statusValue === feedbackStatusEnum.IN_PROGRESS_DONE
      ) {
        //
        this.updateFeedbackModalData.title =
          "feedback.handlingFeedback.completeFeedbackModal.title";
        this.updateFeedbackModalData.content =
          "feedback.handlingFeedback.completeFeedbackModal.content";
      } else {
        this.updateFeedbackModalData.title = "feedback.cancelFeedback.title";
        this.updateFeedbackModalData.content = "";
      }
    },
    onPostCancelFeedback: function() {
      if (
        utils.isEmptyString(this.feedbackComment) &&
        (this.statusValue === feedbackStatusEnum.CANCELED || this.statusValue === feedbackStatusEnum.IN_PROGRESS_CANCEL)
      ) {
        this.showError(this.$t("feedback.content"));
      } else {
        this.isLoading = true
        let data = {
          id: this.feedbackId,
          comment: utils.getCleanStringValue(this.feedbackComment),
          status: this.statusValue,
          fileList: this.getFileList()
        };
        this.POST_FEEDBACK_STATUS(data)
          .then(
            function() {
              this.isLoading = false;
              this.onCloseModal();
              this.$emit("callbackFeedbackCancelAction", true);
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              let mess = error.response.data.message;
              this.showError(mess);
              this.isLoading = false;
            }.bind(this)
          );
      }
    },
    //
    onClickAttachFile: function() {
      let attachFileSelect = this.attachFileList.filter(x => x.enable === true);
      if (attachFileSelect.length === 0) {
        this.uploadPdfFileTitle = "common.addPdfFile";
        this.$refs.componentFilePdfWithFileName.onShowAddNew(
          this.attachFileList.length + 1
        );
      } else if (attachFileSelect.length === 1) {
        this.uploadPdfFileTitle = "common.updatePdfFile";
        this.$refs.componentFilePdfWithFileName.onShowDetail(
          attachFileSelect[0]
        );
      } else {
        this.showError();
      }
    },
    onClickDeleteAttachFile: function() {
      this.attachFileList = this.attachFileList.filter(x => x.enable === false);
    },
    onClickOpenAttachFile: function(url) {
      window.open(url);
    },
    handleUpdateAttachFileList: function(data) {
      let item = {
        id: data.id,
        pdfUrl: data.pdfUrl,
        fileName: data.fileName,
        index: data.index,
        enable: false
      };
      let searchIndex = this.attachFileList.findIndex(
        x => x.index === data.index
      );
      if (searchIndex === -1) {
        this.attachFileList.push(item);
      } else {
        this.attachFileList[searchIndex].id = item.id;
        this.attachFileList[searchIndex].pdfUrl = item.pdfUrl;
        this.attachFileList[searchIndex].fileName = item.fileName;
        this.attachFileList[searchIndex].enable = item.enable;
      }
    },
    //
    onClickImg: function() {
      let imgFileSelect = this.imgList.filter(x => x.enable === true);
      if (imgFileSelect.length === 0) {
        this.uploadPdfFileTitle = "common.addPdfFile";
        this.$refs.componentFilePdfWithFileName.onShowAddNew(
          this.imgList.length + 1
        );
      } else if (imgFileSelect.length === 1) {
        this.uploadPdfFileTitle = "common.updatePdfFile";
        this.$refs.componentFilePdfWithFileName.onShowDetail(imgFileSelect[0]);
      } else {
        this.showError();
      }
    },
    onOpenInputSelectFile: function(index) {
      this.imgUploadIndex = index;
      $(`#upload-img-input`).val("");
      $(`#upload-img-input`).click();
    },
    addAndUpdateImgList: function() {
      if (this.imgUploadIndex > this.imgList.length) {
        let item = {
          url: this.imgUploadData.url
        };
        this.imgList.push(item);
      } else {
        let imgListElement = this.imgList[this.imgUploadIndex];
        imgListElement.url = this.imgUploadData.url;
      }
    },
    onclickRemoveImg: function(index) {
      this.imgList.splice(index, 1);
    },
    handleClick: async function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.getResultFile(files[0]);
      this.imgUploadData.size = files[0].size;
      await this.uploadImgFunction();
      await this.addAndUpdateImgList();
    },
    getResultFile: function(file) {
      let vm = this;
      vm.imgUploadData.file = file;
    },
    uploadImgFunction: async function() {
      if (this.assetImgFileSize > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        this.imgUploadData.url = await uploadFileToMediaAgent(this.imgUploadData.file, "homeMobileApp")
      }
    },
    getFileList: function() {
      let fileList = []
      // img list
      this.imgList.forEach(data=> {
        let item = {
          url: data.url,
          name: null,
          type: 1
        }
        fileList.push(item)
      })
      // attach file
      this.attachFileList.forEach(data=>{
        let item ={
          url: data.pdfUrl,
          name: data.fileName,
          type: 2
        }
        fileList.push(item)
      })
      return fileList
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "POST_FEEDBACK_STATUS",
    ])
  }
};
</script>
<style scoped>
.class-border {
  border: 1px solid #cccccc;
}
.content-border-class {
  border-left: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
}
.attach-file-class {
  max-height: 150px;
  overflow: auto;
  padding: 10px;
}
.attach-file-name:hover {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
}
/*  */
.img-upload-input {
  display: none;
  z-index: -9999;
}
.apartment-img-block {
  display: inline-block;
  margin-bottom: 15px;
}
.apartment-type-class {
  margin: auto;
  /* width: 100%; */
  width: 150px;
  height: 150px;
  object-fit: contain;
  padding: 5px;
  margin: 5px;
  border: 1px solid #cccccc;
  border-radius: 3%;
}
.img-action {
  justify-content: space-between;
  display: flex;
  margin: 0 5px;
  padding: 0 5px;
}

.action-button:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Case/FeedbackCancelActionModal.vue